import React, { useMemo } from "react";
import {
  docenteTieneMultiEtapa,
  normalizeEtapaStage,
} from "../utils/etapasReporte";
import "../ReporteDocente.css";

const LABEL_LAB = "Laboratorio de Buenas Pr\u00e1cticas";

function isNullishVisitField(value) {
  if (value == null) return true;
  const s = String(value).trim();
  return !s || s.toUpperCase() === "NULL";
}

function visitaEsLaboratorio(visita) {
  return (
    isNullishVisitField(visita.stage) ||
    isNullishVisitField(visita.program_name) ||
    isNullishVisitField(visita.grade) ||
    isNullishVisitField(visita.section)
  );
}

const VisitasSection = ({ docente, visitasData, etapasActivas }) => {
  const visitasDelDocente = useMemo(() => {
    if (!docente?.user_id) return [];

    let list = visitasData
      .flatMap((institution) =>
        institution.institutions.flatMap((inst) =>
          inst.teachers.find((t) => t.teacher_id === docente.user_id)
        )
      )
      .filter(Boolean)
      .flatMap((t) => t.visits);

    const multi = docenteTieneMultiEtapa(docente.etapas);
    const activas = etapasActivas instanceof Set ? etapasActivas : new Set();
    if (multi && activas.size > 0) {
      list = list.filter((v) => {
        if (visitaEsLaboratorio(v)) return true;
        const canon = normalizeEtapaStage(v.stage);
        return canon != null && activas.has(canon);
      });
    }

    return list.sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [visitasData, docente?.user_id, docente?.etapas, etapasActivas]);

  if (!docente?.user_id) return null;

  return (
    <div className="card visitas-graficos">
      <div className="visitas-section">
        <h3>Visitas de Seguimiento</h3>

        {visitasDelDocente.length > 0 ? (
          visitasDelDocente.map((visita, index) => {
            const visitaDate = new Date(visita.date);
            const year = visitaDate.getFullYear();
            const dayMonth = visitaDate.toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "long",
            });

            const esLab = visitaEsLaboratorio(visita);

            return (
              <div key={index} className="visit-card">
                <div className="visit-date-container">
                  <div className="visit-year">{year}</div>
                  <div className="visit-day-month">{dayMonth}</div>
                </div>
                <div className="visit-info">
                  {esLab ? (
                    <div className="visit-stage">{LABEL_LAB}</div>
                  ) : (
                    <>
                      <div className="visit-stage">{`Etapa: ${visita.stage}`}</div>
                      <div className="visit-program">
                        {`Programa: ${visita.program_name}`}
                      </div>
                      <div className="visit-grade-section">
                        {visita.grade} {visita.section}
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <p className="no-visits-message">
            Para este momento pedagógico no se han registrado visitas de
            acompañamiento para este docente
            {docenteTieneMultiEtapa(docente.etapas)
              ? " con las etapas seleccionadas"
              : ""}
            .
          </p>
        )}
      </div>
    </div>
  );
};

export default VisitasSection;
